import React from "react";
import { Link } from "react-router-dom";
import LegalLayout, { DataCard } from "../components/legal/LegalLayout";
import { company, hosting } from "../legal/company";

// Rows without a value are skipped until they are filled in company.js.
const publisherRows = [
  ["Company", company.legalName || company.name],
  ["Legal form", company.legalForm],
  ["Share capital", company.shareCapital],
  ["Registered office", company.address],
  ["Trade register (RC)", company.rcNumber],
  ["ICE", company.ice],
  ["Tax ID (IF)", company.taxId],
  ["Publication director", company.publicationDirector],
].filter(([, value]) => value);

const sections = [
  {
    id: "publisher",
    title: "1. Website publisher",
    content: (
      <>
        <p>
          The website {company.website.replace("https://", "")} is published
          by:
        </p>
        <DataCard>
          <dl>
            {publisherRows.map(([label, value]) => (
              <React.Fragment key={label}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </React.Fragment>
            ))}
            <dt>Email</dt>
            <dd>
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </dd>
            <dt>Phone</dt>
            <dd>
              <a href={company.phoneHref}>{company.phone}</a>
            </dd>
          </dl>
        </DataCard>
      </>
    ),
  },
  {
    id: "hosting",
    title: "2. Hosting",
    content: (
      <DataCard>
        <dl>
          <dt>Host</dt>
          <dd>{hosting.name}</dd>
          <dt>Address</dt>
          <dd>{hosting.address}</dd>
          <dt>Website</dt>
          <dd>
            <a href={hosting.website} target="_blank" rel="noopener noreferrer">
              {hosting.website.replace("https://", "")}
            </a>
          </dd>
        </dl>
      </DataCard>
    ),
  },
  {
    id: "intellectual-property",
    title: "3. Intellectual property",
    content: (
      <p>
        All content on this website, including text, design, graphics and the
        Code Solutions name and logo, is the property of Code Solutions or its
        licensors, unless stated otherwise. Third-party trademarks and logos
        belong to their respective owners. Any reproduction without prior
        written permission is prohibited. See our{" "}
        <Link to="/terms-of-use">Terms of Use</Link> for details.
      </p>
    ),
  },
  {
    id: "personal-data",
    title: "4. Personal data",
    content: (
      <>
        <p>
          Personal data collected through this website is processed in
          accordance with Moroccan Law No. 09-08 on the protection of
          individuals with regard to the processing of personal data. Our{" "}
          <Link to="/privacy-policy">Privacy Policy</Link> explains what we
          collect and how to exercise your rights.
        </p>
        {company.cndpReference && (
          <p>
            CNDP declaration reference: <strong>{company.cndpReference}</strong>
          </p>
        )}
      </>
    ),
  },
  {
    id: "contact",
    title: "5. Contact",
    content: (
      <p>
        For any question about this website, contact us at{" "}
        <a href={`mailto:${company.email}`}>{company.email}</a>.
      </p>
    ),
  },
];

const LegalNotice = () => (
  <LegalLayout
    title="Legal Notice"
    description="Legal information about Code Solutions, publisher of this website, and its hosting provider."
    intro="Legal information about the company that publishes this website and the provider that hosts it."
    path="/legal-notice"
    sections={sections}
  />
);

export default LegalNotice;
